// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__0282840b","trigger_wrapper":"trigger_wrapper__0282840b","trigger":"trigger__0282840b","content":"content__0282840b"};